module.exports = __webpack_public_path__ + "img/schedule_icon.333638ce.svg";